<template>
  <div class="breadcrumb">
    <div class="back-option">
      <router-link v-if="invoice" :to="{ name: back , params: { invoiceId: invoice.id }}">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </router-link>
      <router-link v-else :to="{ name: back }">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </router-link>
    </div>
    <div class="dropdown">
      <div class="dropdown-selected">Wallet</div>
    </div>
    <div class="action-button">
      <DatePicker class="ml-15"
        v-model="selectedMonth"
        @change="dateSelectTerm"
        type="month"
        :clearable="false"
        size="small"
      />
      <button class="btn btn-primary" @click="download">Download unused</button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    back: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedMonth: new Date(),
      invoice: {},
    };
  },

  methods: {
    dateSelectTerm(date) {
      const month = new Date(date).getMonth() + 1;
      const year = new Date(date).getFullYear();
      this.$emit('onChangeMonth', { month, year });
    },

    async download() {
      const month = new Date(this.selectedMonth).getMonth() + 1;
      const year = new Date(this.selectedMonth).getFullYear();
      try {
        await this.$store.dispatch('wallet/downloadConsolidatedWalletReport', { month, year });
      } catch (error) {
        this.$error({
          message: error.getMessage() || error.toString(),
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
